import React from 'react';
import ReactDOM from 'react-dom';

import Slider from '../components/organisms/Slider';
import Slide from '../components/molecules/Slide';
import SlideCTA from '../components/molecules/SlideCTA';

import { ParallaxProvider } from "react-scroll-parallax";

const el = document.querySelector('#carousel-slider-container');
if (el) {
	const data = window.shake_win_slider;
	if (data) {
		ReactDOM.render(
		<ParallaxProvider>
			<Slider heading={data.heading}>
				<React.Fragment>
					{data.items.map((item, index) => (
						<Slide primary key={index} item={item} large={data.large} />
					))}
					{data.cta &&
						<SlideCTA copy={data.cta.copy} link={data.cta.link} />
					}
				</React.Fragment>
			</Slider>
		</ParallaxProvider>,
		el);
	}
}
